import { render } from "./BaseDialog.vue?vue&type=template&id=4b309ceb&scoped=true"
import script from "./BaseDialog.vue?vue&type=script&lang=js"
export * from "./BaseDialog.vue?vue&type=script&lang=js"

import "./BaseDialog.vue?vue&type=style&index=0&id=4b309ceb&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-4b309ceb"
/* hot reload */
if (module.hot) {
  script.__hmrId = "4b309ceb"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4b309ceb', script)) {
    api.reload('4b309ceb', script)
  }
  
  module.hot.accept("./BaseDialog.vue?vue&type=template&id=4b309ceb&scoped=true", () => {
    api.rerender('4b309ceb', render)
  })

}

script.__file = "src/ui/BaseDialog.vue"

export default script